import L from 'leaflet';

// Athlone, Ireland - this app's home market, used as the map fallback when there's
// nothing else (no ride coords, no online vehicles) to center on
export const DEFAULT_MAP_CENTER = [53.4239, -7.9407];

// Fix default marker icons broken by webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl:       require('leaflet/dist/images/marker-icon.png'),
  shadowUrl:     require('leaflet/dist/images/marker-shadow.png'),
});

const shadowUrl = require('leaflet/dist/images/marker-shadow.png');
const iconsBase = process.env.PUBLIC_URL + '/icons';

export const greenIcon = new L.Icon({
  iconUrl: `${iconsBase}/marker-icon-2x-green.png`,
  shadowUrl,
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

export const orangeIcon = new L.Icon({
  iconUrl: `${iconsBase}/marker-icon-2x-orange.png`,
  shadowUrl,
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

export const carIcon = L.divIcon({
  html: '<div style="font-size:26px;line-height:1;filter:drop-shadow(0 2px 4px rgba(0,0,0,.5))">🚗</div>',
  className: '',
  iconSize: [32, 32],
  iconAnchor: [16, 16],
  popupAnchor: [0, -20],
});
